import { CloseOutlined } from "@mui/icons-material";
import { Dialog, IconButton, useMediaQuery } from "@mui/material";
import { useTourById } from "../../services/hooks/useTours";
import MapComponent from './map.component';
import { useToursContext } from '../../contexts/tour-context';
import TourDrawer from "./tour-drawer/tour-drawer-scene.component";

export default function MobileModal({ mobileModal, setMobileModal }) {
    const { clickedTourId } = useToursContext();
    const { clickedTourData } = useTourById(clickedTourId);
    const matches = useMediaQuery('(min-width:600px)');

    return (
        <Dialog
            fullScreen
            open={mobileModal}
            onClose={() => setMobileModal(false)}
            sx={{
                '.MuiPaper-root': {
                    overflowY: 'clip'
                }
            }}
        >
            <IconButton sx={{
                position: 'absolute', top: 5, right: 5,
                background: 'white', zIndex: 500,
                ':hover': { bgcolor: 'rgb(255 255 255 / 80%)' }
            }}
                onClick={() => setMobileModal(false)}>
                <CloseOutlined />
            </IconButton>
            <MapComponent />
            {!matches ? <TourDrawer clickedTourData={clickedTourData} /> : null}
        </Dialog>
    )
}